<template>
  <div class="chats">
    <div class="c-middle">
      <div
        class="relation-item c_pointer"
        :class="item._id == relationId ? 'active' : ''"
        v-for="(item, i) in relations"
        :key="i"
        @click="relationClick(item._id, true)"
      >
        <div class="relation-item-left">
          <el-badge :value="item.exts.newCount || ''" :max="99">
            <img class="relation-item-avatar" :src="item.sendUserAvatar || '../assets/user.png'" />
          </el-badge>
        </div>
        <div class="relation-item-right">
          <div class="relation-item-top">
            <div class="relation-item-name">{{ item.sendUserName }}</div>
            <div class="relation-item-sendTime">{{ item.updateTime }}</div>
          </div>
          <div class="relation-item-content">{{ item.exts.lastMessage || '' }}</div>
        </div>
      </div>
    </div>
    <div class="c-right">
      <div class="chat-history" id="history">
        <div
          v-for="(item, i) in chats"
          :key="i"
          class="chat-item"
          :class="userId == item.sendUserId ? 'sendByMe' : ''"
          :id="item._id"
        >
          <div class="chat-item-left">
            <img class="chat-item-avatar" :src="item.sendUserAvatar || '../assets/user.png'" />
          </div>
          <div class="chat-item-middle"></div>
          <div class="chat-item-right">
            <div class="chat-item-top">
              <div class="chat-item-sendTime c_m_r_n">{{ item.sendUserName }}</div>
              <div class="chat-item-sendTime">{{ item.createTime }}</div>
            </div>
            <div class="chat-item-content">{{ item.message }}</div>
          </div>
        </div>
      </div>
      <div class="chat-message">
        <el-input
          type="textarea"
          :rows="8"
          v-model="message"
          class="chat-input"
          @keydown.enter.native="sendMessage"
          placeholder="快捷键：“回车”发送，“shift+回车”换行。"
        ></el-input>
        <div class="chat-tool">
          <div></div>
          <el-button type="primary" @click="sendMessage">发送</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    window.$this = this;
    return {
      userId: '',
      relations: [],
      chats: [],
      relationId: '',
      message: '',
      timer: null,
      page: 1,
      rows: 10,
      loadingState: false // 是否正在请求
    };
  },
  inject: ['getNavNewMessageCount'],
  mounted() {
    this.userId = JSON.parse(sessionStorage['loginAccount'])._id;

    // 每隔20秒查询1次所有的会话，用来表示未读消息数量
    this.getRelations(true);
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.getRelations(true);
    }, 10000);

    // 监听消息窗口滚动条，当滚动到顶部时查询历史消息
    this.$nextTick(() => {
      this.historyEle = document.getElementById('history');
      this.historyEle.addEventListener('scroll', this.handleScroll);
    });
  },
  methods: {
    // 查询所有会话
    getRelations(all) {
      this.osg.ajax(
        '/chatMessage/relationList.do',
        {
          relationId: all ? null : this.relationId,
          sortField: 'updateTime',
          sortOrder: 'desc'
        },
        res => {
          this.relations = res.data;
          // let unreads = [];
          // let reads = [];
          // for(var i = 0,len = res.data ;  i < len.length; i++){
          //   if(len[i].exts.newCount > 0){
          //     unreads.push(len[i]);
          //   }else{
          //     reads.push(len[i]);
          //   }
          // }
          //     this.relations = unreads.concat(reads);

          if (res.data.length > 0) {
            if (!this.relationId) {
              // 默认点开第一个聊天
              this.relationClick(res.data[0]._id);
            } else {
              let has = false;
              // 如果当前聊天有新消息，则请求新消息
              for (let item of res.data) {
                if (item._id == this.relationId) {
                  if (item.exts.newCount > 0) {
                    has = true;
                    this.relationClick(this.relationId);
                  }
                  break;
                }
              }
              // 更新顶部消息个数
              if (!has) this.getNavNewMessageCount();
            }
          }
        },
        { noload: true }
      );
    },
    // 查询点击/指定会话，最新1页的消息
    relationClick(relationId, handleClick) {
      // 点击会话消息，清除消息数量标志
      if (handleClick) {
        for (let item of this.relations) {
          if (item._id == relationId) {
            item.exts.newCount = 0;
            break;
          }
        }
      }
      this.page = 1;
      this.chats = [];
      this.loadingState = true;
      this.relationId = relationId;
      this.$forceUpdate();
      this.getMessage();
    },
    // 创建时间倒叙查询 具体会话的分页消息
    getMessage() {
      this.osg.ajax(
        '/chatMessage/query.do',
        {
          relationId: this.relationId,
          page: this.page,
          rows: this.rows,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.getNavNewMessageCount();
          if (res.data.length > 0) {
            // 查询到消息时，颠倒数组后 拼接历史会话
            this.chats = res.data.reverse().concat(this.chats);
            this.$nextTick(() => {
              // 滚动到当前页最新数据位置，当前会话相同时 不触发滚动
              document.getElementById(res.data[res.data.length - 1]._id).scrollIntoView();
              this.loadingState = false;
            });
          } else {
            this.osg.toast('没有消息了');
          }
        },
        { noload: true }
      );
    },
    sendMessage(e) {
      if (e.shiftKey || !String(this.message).trim()) return;
      this.osg.ajax(
        '/chatMessage/sendMessage.do',
        { relationId: this.relationId, message: this.message },
        () => {
          this.message = '';
          this.relationClick(this.relationId);
        }
      );
    },
    // 消息窗口滚动条滚动
    handleScroll() {
      if (this.loadingState) return; // 节流
      if (this.historyEle.scrollTop <= 50) {
        this.loadingState = true;
        this.page++;
        this.getMessage();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.chats {
  padding: 0px;
  display: flex;
  flex-direction: row;
  .c-middle {
    width: 300px;
    overflow-x: hidden;
    overflow-y: auto;
    .relation-item {
      padding: 15px;
      display: flex;
      .relation-item-left {
        display: flex;
        margin-right: 15px;
        .relation-item-avatar {
          width: 50px;
          height: 50px;
          border-radius: 8px;
          overflow: hidden;
        }
      }
      .relation-item-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .relation-item-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .relation-item-sendTime {
            font-size: 14px;
            color: #acacac;
          }
        }
        .relation-item-content {
          font-size: 14px;
          color: #acacac;
        }
      }
    }
    .relation-item.active {
      background-color: #dedede;
    }
  }
  .c-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    background-color: #fafafa;
    .chat-history {
      flex: 1;
      overflow-y: auto;
      .chat-item {
        padding: 15px;
        display: flex;
        .chat-item-left {
          display: flex;
          .chat-item-avatar {
            width: 50px;
            height: 50px;
            border-radius: 8px;
            overflow: hidden;
          }
        }
        .chat-item-middle {
          width: 15px;
        }
        .chat-item-right {
          max-width: 300px;

          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .chat-item-top {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .chat-item-sendTime {
              font-size: 12px;
              color: #acacac;
            }
          }
          .chat-item-content {
            background-color: #fff;
            padding: 5px;
            margin-top: 5px;
            border-radius: 4px;
            font-size: 16px;
          }
        }
      }
      .chat-item.sendByMe {
        flex-direction: row-reverse;
        .chat-item-top {
          flex-direction: row-reverse;
        }
      }
    }
    .chat-message {
      //   border-top: 1px solid #e0e0e0;
      padding: 15px;
      height: 250px;
      .chat-input {
        box-sizing: border-box;
      }
      .chat-tool {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
      }
    }
  }
}
</style>
